import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';
import {ITerritory, Territory} from 'app/blocks/model/territory.model';
import {TerritoryService} from 'app/blocks/service/territory.service';
import {Router} from '@angular/router';
import {Resource} from 'app/constants/resource';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class TerritoryResource extends AbstractEntityResource<ITerritory> {
    constructor(territoryService: TerritoryService, router: Router) {
        super(
            Resource.TERRITORIES,
            territoryService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.TERRITORIES, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.TERRITORIES),
            (entity?) => new Territory(entity),
            (entity) => entity.id
        );
    }
}
